import React, { useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Card, Grid, CircularProgress, Alert } from "@mui/material";
import { postUploadNoResponse } from "utils/WebService";
import fileDownload from 'js-file-download';
import { MySwal } from "App";
import { useMaterialUIController } from "context";

function ImportarRetorno() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [resultado, setResultado] = useState(null);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setFile(e.target.files[0]);
            setResultado(null);
        }
    };

    const handleUpload = () => {
        if (!file) {
            MySwal.fire('Aviso', 'Selecione um arquivo de retorno (.ret) primeiro.', 'warning');
            return;
        }

        MySwal.fire({
            title: 'Deseja importar o arquivo?',
            text: "Caso este arquivo já tenha sido processado anteriormente, os registros já baixados ou atualizados serão ignorados automaticamente.",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#4CAF50',
            cancelButtonColor: '#f44336',
            confirmButtonText: 'Sim, processar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                const formData = new FormData();
                formData.append("file", file);

                postUploadNoResponse('/cnab/processar-retorno', formData)
                    .then(async (response) => {
                        const blob = await response.blob();
                        fileDownload(blob, "Relatorio_Baixa_Automatica_CNAB.pdf");
                        setResultado({ type: 'success', message: 'Processamento concluído com sucesso. O relatório em PDF de Pagamentos Efetuados foi gerado e baixado automaticamente.' });
                        MySwal.fire('Sucesso', 'Arquivo de retorno processado!', 'success');
                        setFile(null);
                    })
                    .catch(err => {
                        console.error(err);
                        const msg = err.message || 'Erro ao processar o arquivo de retorno.';
                        setResultado({ type: 'error', message: msg });
                        MySwal.fire('Erro', msg, 'error');
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        });
    };

    return (
        <MDBox>
            <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} md={8}>
                    <MDTypography variant="h6" fontWeight="medium" color={darkMode ? "white" : "dark"}>
                        Importar Arquivo de Retorno (.ret)
                    </MDTypography>
                    <MDTypography variant="button" color={darkMode ? "white" : "text"} fontWeight="regular">
                        Selecione o arquivo de retorno disponibilizado pelo Bradesco para processar baixas, registros e rejeições.
                    </MDTypography>
                </Grid>
                
                <Grid item xs={12}>
                    <input
                        accept=".ret,.txt"
                        style={{ display: 'none' }}
                        id="raised-button-file"
                        type="file"
                        onChange={handleFileChange}
                    />
                    <label htmlFor="raised-button-file">
                        <MDButton variant="outlined" color={darkMode ? "white" : "info"} component="span">
                            Selecionar Arquivo
                        </MDButton>
                    </label>
                    {file && (
                        <MDTypography variant="body2" sx={{ ml: 2, display: 'inline-block', color: darkMode ? "white" : "inherit" }}>
                            Arquivo selecionado: <strong>{file.name}</strong>
                        </MDTypography>
                    )}
                </Grid>

                <Grid item xs={12}>
                    <MDButton 
                        variant="gradient" 
                        color="success" 
                        onClick={handleUpload}
                        disabled={!file || loading}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'PROCESSAR ARQUIVO'}
                    </MDButton>
                </Grid>

                {resultado && (
                    <Grid item xs={12}>
                        <Alert severity={resultado.type}>
                            {resultado.message}
                        </Alert>
                    </Grid>
                )}
            </Grid>
        </MDBox>
    );
}

export default ImportarRetorno;
